import React, { Component } from 'react'
import { Container } from 'components/Layout'
import NumbersEnableFlowsForm from '../NumbersEnableFlowsForm'
import HeadingBanner from 'components/Text/HeadingBanner'

import sText from 'components/Text/Text.scss'

export default class NumbersEnableFlowsModal extends Component {
  render() {
    const { modalConfirm, serviceId, ban, phoneNumber, modalCancel } = this.props
    return (
      <div>
        <HeadingBanner filled>
          <h2 className={sText.heading3}>Enable Call Flows</h2>
          <div className={sText.descrip1}>Advanced call routing and IVR</div>
        </HeadingBanner>
        <Container paddingTop paddingBottom className="sm">
          <NumbersEnableFlowsForm
            ban={ban}
            serviceId={serviceId}
            phoneNumber={phoneNumber}
            afterSubmit={modalConfirm}
            onCancel={modalCancel}
          />
        </Container>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersEnableFlowsModal/NumbersEnableFlowsModal.jsx